import { Injectable, Output, EventEmitter } from '@angular/core';
import { User } from '../model/user';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UserSessionService {

    user: User;
    // tslint:disable-next-line:no-output-on-prefix
    @Output() onUserChange: EventEmitter<User> = new EventEmitter<User>();

    // prittvate userSource = new BehaviorSubject<User>(null);
    // user = this.userSource.asObservable();

    // constructor() { }

    setUser(user: User) {
        // this.userSource.next(user);
        this.user = user;
        this.onUserChange.emit(this.user);
    }

    getUser(): User {
        return this.user;
        // return this.userSource.getValue();
    }
}
